<template>
  <div>
    <div class="container is-fluid">
      <nav class="navbar journal-menu" role="navigation" aria-label="main navigation">
        <div class="navbar-menu">
          <div class="navbar-start">
            <div class="navbar-item has-dropdown is-hoverable">
              <a class="navbar-link">New</a>
              <div class="navbar-dropdown">
                <a
                  @click="$store.dispatch('journal/createRootFolder','New Folder')"
                  class="navbar-item"
                >Folder</a>
              </div>
            </div>
            <a
              @click="$store.dispatch('journal/closeAllFolders')"
              class="navbar-item"
            >Close All Folders</a>
          </div>
        </div>
      </nav>

      <div class="columns">
        <div class="column">
          <table class="table is-fullwidth is-bordered is-striped">
            <tbody>
              <tr v-for="item in journalFolders" :key="item.id">
                <td>
                  <a
                    v-if="$store.state.journal.folderBeingRenamed != item.id"
                    @click="toggleActive(item.id)"
                  >
                    <span class="icon">
                      <font-awesome-icon class="folder" :icon="FolderIcon(item.id)" />
                    </span>
                    {{item.name}}
                  </a>
                  <a
                    v-if="$store.state.journal.folderBeingRenamed == item.id && $store.state.folderBeingMoved == null"
                  >
                    <span class="icon">
                      <font-awesome-icon class="folder" :icon="FolderIcon(item.id)" />
                    </span>
                    <input
                      class="input is-small rename-input"
                      v-model="renamingName"
                      type="text"
                      v-on:keyup.enter="renameFolder(item.id)"
                    />
                  </a>
                  <div class="is-pulled-right">
                    <a
                      title="Confirm renaming"
                      v-tippy
                      v-if="$store.state.journal.folderBeingRenamed == item.id"
                      @click="renameFolder(item.id)"
                    >Confirm</a>
                    <a
                      title="Cancel renaming"
                      v-tippy
                      v-html=" ' Cancel'"
                      v-if="$store.state.journal.folderBeingRenamed == item.id"
                      @click="$store.dispatch('journal/cancelRenamingFolder')"
                    ></a>
                    <a
                      v-if="!$store.state.journal.folderBeingMoved && $store.state.journal.folderBeingRenamed == null"
                      @click="$store.dispatch('journal/createFolder',{FolderName:'New Folder',parentFolderId:item.id})"
                    >
                      <span title="Make a new folder" v-tippy class="icon">
                        <font-awesome-icon class="folder" :icon="'plus-square'" />
                      </span>
                    </a>
                    <a
                      title="Move this folder"
                      v-tippy
                      v-if="!$store.state.journal.folderBeingMoved && !$store.state.journal.movingFile && $store.state.journal.folderBeingRenamed == null"
                      @click="startMovingFolder(item.id)"
                    >
                      <span class="icon">
                        <font-awesome-icon icon="arrows-alt" />
                      </span>
                    </a>

                    <a
                      title="Cancel the folder movement"
                      v-tippy
                      v-if="$store.state.journal.folderBeingMoved && $store.state.journal.folderBeingMoved == item.id"
                      @click="cancelFolderMove()"
                    >Cancel</a>

                    <a
                      v-if="!$store.state.journal.folderBeingMoved && $store.state.journal.folderBeingRenamed == null"
                      @click="$store.dispatch('journal/startDeleting',item.id)"
                    >
                      <span title="Delete folder" v-tippy class="icon">
                        <font-awesome-icon class="folder" :icon="'minus-circle'" />
                      </span>
                    </a>
                    <a
                      v-if="!$store.state.journal.folderBeingMoved && $store.state.journal.folderBeingRenamed == null"
                      @click="startRenamingFolder(item.name,item.id)"
                    >
                      <span title="Rename folder" v-tippy class="icon">
                        <font-awesome-icon class="folder" :icon="'edit'" />
                      </span>
                    </a>
                    <a
                      title="Move the selected folder here"
                      v-tippy
                      v-if="$store.state.journal.folderBeingMoved && $store.state.journal.folderBeingMoved != item.id"
                      @click="moveItem(item.id)"
                    >Here</a>
                    <a
                      title="Move the selected file here"
                      v-tippy
                      v-if="$store.state.journal.movingFile"
                      @click="$store.dispatch('journal/moveFile',item.id)"
                    >Here</a>
                  </div>
                  <JournalItem
                    v-show="$store.state.journal.openFolders.includes(item.id)"
                    :items="item"
                  />
                </td>
              </tr>
              <tr>
                <table
                  v-if="journalRootFiles.length>0"
                  class="table is-fullwidth is-hoverable is-bordered is-striped"
                >
                  <thead>
                    <tr>
                      <th>Document Name</th>
                      <th>Updated At</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="file in journalRootFiles" :key="file.id">
                      <td>
                        <a @click="goToDocument(file.id)">
                          <span class="icon is-small">
                            <img src="@/assets/img/icons/file.svg" />
                          </span>
                          {{file.name}}
                        </a>
                        <div class="is-pulled-right">
                          <a
                            title="Move this file"
                            v-tippy
                            v-if="!$store.state.journal.movingFile"
                            @click="$store.dispatch('journal/startMovingFile',file.id)"
                          >
                            <span class="icon">
                              <font-awesome-icon class="folder" icon="arrows-alt" />
                            </span>
                          </a>
                          <a
                            title="Delete file"
                            v-tippy
                            v-if="!$store.state.journal.movingFile"
                            @click="$store.dispatch('journal/startDeletingFile',file.id)"
                          >
                            <span class="icon">
                              <font-awesome-icon class="folder" :icon="'minus-circle'" />
                            </span>
                          </a>
                          <a
                            title="Cancel the file movement"
                            v-tippy
                            v-if="$store.state.journal.fileBeingMoved == file.id"
                            @click="$store.dispatch('journal/stopMovingFile')"
                          >Cancel</a>
                        </div>
                      </td>
                      <td>{{file.updated_at}}</td>
                    </tr>
                  </tbody>
                </table>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal" :class="{'is-active':$store.state.journal.deletingFolder}">
        <div class="modal-background" @click="$store.dispatch('journal/stopDeleting')"></div>
        <div class="modal-content box">
          <p>Are you sure you want to delete?</p>
          <button class="button is-link" @click="$store.dispatch('journal/deleteFolder')">Confirm</button>
          <button class="button is-link" @click="$store.dispatch('journal/stopDeleting')">Cancel</button>
        </div>
      </div>
      <div class="modal" :class="{'is-active':$store.state.journal.fileDeleting}">
        <div class="modal-background" @click="$store.dispatch('journal/cancelFileDelete')"></div>
        <div class="modal-content box">
          <p>Are you sure you want to delete?</p>
          <button class="button is-link" @click="$store.dispatch('journal/deleteFile')">Confirm</button>
          <button class="button is-link" @click="$store.dispatch('journal/cancelFileDelete')">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseHelper from "@/helpers/BaseHelper";

import { JournalClient } from "@/clients/JournalClient";
import fileBrowser from "@/components/files/Browser.vue";
import { mapState } from "vuex";
import JournalItem from "@/components/journal/JournalItem.vue";

export default {
  name: "Journal",
  mixins: [BaseHelper],

  components: {
    fileBrowser,
    JournalItem
  },

  data() {
    return {
      renamingName: "",
      newFolderName: "",
      folderDeleteId: null,
      documentAttachFolderId: null,
      documentAttachId: null,
      moveFolderId: null,
      moveParentFolderId: null,
      active: []
    };
  },

  computed: {
    ...mapState({
      journalFolders(state) {
        return state.journal.journal.filter(element => {
          return element.type == "folder";
        });
      },
      journalRootFiles(state) {
        return state.journal.journal.filter(element => {
          return element.type == "file";
        });
      }
    })
  },
  methods: {
    renameFolder(FolderId) {
      this.$store.dispatch("journal/renameFolder", this.renamingName);
      this.renamingName = "";
    },
    startRenamingFolder(name, id) {
      this.renamingName = name;
      this.$store.dispatch("journal/startRenamingFolder", id);
    },
    cancelFolderMove() {
      this.$store.dispatch("journal/cancelFolderMove");
    },
    moveItem(FolderId) {
      this.$store.dispatch("journal/chooseFolderTarget", FolderId);
      this.$store.dispatch("journal/moveFolder");
    },
    startMovingFolder(FolderId) {
      this.$store.dispatch("journal/startMovingFolder", FolderId);
    },
    StartMakingFolder() {
      this.$store.dispatch("journal/startNewFolder");
    },
    FolderIcon(FolderId) {
      if (this.$store.state.journal.openFolders.includes(FolderId)) {
        return "folder-open";
      } else {
        return "folder";
      }
    },
    toggleActive(FolderId) {
      this.$store.dispatch("journal/toggleOpenFolder", FolderId);
    },
    removeAllElements(array, elem) {
      var index = array.indexOf(elem);
      while (index > -1) {
        array.splice(index, 1);
        index = array.indexOf(elem);
      }
    },
    moveFolder(FolderId, parentFolderId) {
      JournalClient.MoveFolder(FolderId, parentFolderId)
        .then(response => {
          console.log(response);
          this.getJournal();
        })
        .catch(err => {
          console.log(err);
        });
    },
    attachAllDocumentsToRoot() {
      this.journal.forEach(element => {
        if (element.type == "file") {
          let FolderId = "lsFJECIE3Gca8GU";
          this.attachDocument(FolderId, element.id);
        }
      });
    },
    attachDocument(FolderId, DocumentId) {
      JournalClient.AttachDocument(FolderId, DocumentId)
        .then(response => {
          console.log(response);
          this.getJournal();
        })
        .catch(err => {
          console.log(err);
        });
    },
    deleteFolder(FolderId) {
      JournalClient.DeleteFolder(FolderId)
        .then(response => {
          console.log(response);
          this.getJournal();
        })
        .catch(err => {
          console.log(err);
        });
    },
    makeFolder(FolderName) {
      JournalClient.CreateFolder(FolderName)
        .then(response => {
          console.log(response);
          this.getJournal();
        })
        .catch(err => {
          console.log(err);
        });
    },
    getJournal() {
      JournalClient.GetJournal()
        .then(response => {
          console.log(response.data);
          this.journal = response.data.journal;
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    this.$store.dispatch("journal/getJournal");
  }
};
</script>

<style lang="scss" >
@import "@/assets/scss/variables.scss";
.journal-menu {
  z-index: 1;
}
.button.is-link {
  font-weight: bold !important;
  border-color: $pantoneBlue !important;
  color: $pantoneBlue !important;
  background-color: transparent !important;
  &.is-active {
    background-color: $pantoneBlue !important;
    color: white !important;
  }
  &:hover {
    background-color: $pantoneBlue !important;
    color: white !important;
  }
}

.rename-input {
  width: fit-content;
}
</style>


